import config from '@/config';
import AppleMacLogo from '@/geolocation/icons/AppleMacLogo';
import WindowsLogo from '@/geolocation/icons/WindowsLogo';
import useSoftReload from '@/lostHooks/softReload/useSoftReload';
import { useStore } from '@/store/useStore';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
const { installerKey, version } = config.geoComply?.plc ?? {};

const DownloadPluginSteps = () => {
  const { t } = useTranslation();
  const userOS = useStore((s) => s.runtime.userOS);
  const navigate = useNavigate();
  const { reload } = useSoftReload();
  const userId = useStore((s) => s.userSessionContext.userId);

  const generateDownloadUrl = (
    installerKey: string,
    version: string,
    userOS?: string,
    isProduction?: boolean,
    userId?: string,
  ) => {
    //TODO: this needs to be handled better by using "process.env.NODE_CONFIG_ENV"
    const prefix = isProduction ? 'https://' : 'https://stg-';
    const topLevelDomain = isProduction ? 'com' : 'net';

    let downloadUrl = `${prefix}ums.geocomply.${topLevelDomain}/installer/url?id=${installerKey}&version=${version}`;

    if (userOS) {
      downloadUrl += `&os=${userOS}`;
    }

    if (userId) {
      downloadUrl += `&user_id=${userId}`;
    }

    return downloadUrl;
  };

  const downloadPluginUrl = generateDownloadUrl(
    installerKey,
    version,
    userOS,
    false,
    userId as string,
  );

  const goBack = () => {
    navigate(-1);
    reload({ preset: 'geolocation-retry' });
  };

  const logo = userOS === 'mac' ? <AppleMacLogo /> : <WindowsLogo />;

  return (
    <div className="download-plugin-steps">
      {logo}
      <ol>
        <li>
          <a href={downloadPluginUrl} className="btn btn__link btn-main">
            {t('downloadPluginSteps.download')}
          </a>
        </li>
        <li>
          <h5 className="subtitle">{t('downloadPluginSteps.install')}</h5>
          <p>{t('downloadPluginSteps.pluginHasDownloaded')}</p>
        </li>
        <li>
          <h5 className="subtitle">{t('global.play')}</h5>
          <p>{t('downloadPluginSteps.pluginSuccessfullyInstalled')}</p>
        </li>
        <li>
          <a onClick={() => goBack()} className="btn btn__link btn-main">
            {t('global.play')}
          </a>
        </li>
      </ol>
    </div>
  );
};

export default DownloadPluginSteps;
